import styled from 'styled-components';
import { Colors } from '../../../theme';
import { button } from '../styles/fonts';
import { StyledLinkV2 } from '../styles/ui';
export const CustomLink = styled(StyledLinkV2) `
  &.MuiLink-root {
    display: flex;
    padding: 8px;
    margin: 0 0 16px;
    border: 2px solid transparent;
    ${button};
    border-radius: 12px;
    outline: none;

    &:hover {
      color: ${Colors.blue400};
      background-color: ${Colors.white};
    }

    &:focus,
    &:active {
      color: ${Colors.grey900};
      outline: 2px solid ${Colors.blue300};
      outline-offset: 2px;
    }
  }

  &:last-child {
    margin: 0;
  }
`;
//# sourceMappingURL=styles.js.map